import { render, staticRenderFns } from "./goldsetting.vue?vue&type=template&id=4e0751b2&scoped=true"
import script from "./goldsetting.vue?vue&type=script&lang=js"
export * from "./goldsetting.vue?vue&type=script&lang=js"
import style0 from "./goldsetting.vue?vue&type=style&index=0&id=4e0751b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0751b2",
  null
  
)

export default component.exports